import { View, Text } from "@react-pdf/renderer";
import { COLORS, styles } from "../../../../forms/pdf-components/PdfStyles";
import { PdfH2, PdfNote } from "../../../../forms/pdf-components/PdfText";
import {
  PdfRow,
  PdfCol,
  PdfSection,
  PdfVerticalDivider,
} from "../../../../forms/pdf-components/PdfLayout";
import { PdfCheckItem } from "../../../../forms/pdf-components/PdfCheckItem";

const PHARMACY_USE_OPTIONS = [
  {
    label: "Change Rx: Update Rx, not filled as prescribed",
    value: "change-update",
  },
  {
    label: "No Change to Rx: Continue with original Rx",
    value: "no-change",
  },
  {
    label: "Change Rx: Change Drug, Dose, or Regimen",
    value: "change-drug",
  },
];

/**
 * PdfPharmacyUseOnly
 *
 * No dynamic data — all checkboxes are always unchecked.
 * PINs are static.
 */
export const PdfPharmacyUseOnly = () => (
  <PdfSection>
    <PdfRow style={{ alignItems: "flex-start" }}>
      {/* Left — checkbox list */}
      <PdfCol>
        <PdfH2 style={{ marginBottom: 4 }}>
          Pharmacy Use Only - Select Only One Outcome
        </PdfH2>
        {PHARMACY_USE_OPTIONS.map((opt) => (
          <PdfCheckItem key={opt.value} label={opt.label} checked={false} />
        ))}
      </PdfCol>

      <PdfVerticalDivider style={{ marginVertical: 0 }} />

      {/* Right — cross-reference note + PINs */}
      <PdfCol style={{ paddingLeft: 6, maxWidth: 180 }}>
        <View style={{ flexDirection: "row", marginBottom: 4 }}>
          <Text style={[styles.inlineBold, { color: COLORS.text }]}>*</Text>
          <Text
            style={[
              styles.pinNote,
              { flex: 1, fontWeight: 600 },
            ]}
          >
            {" "}
            This form must be cross referenced to the pharmacy hardcopy
            --Rx/Ttx
          </Text>
        </View>
        <PdfNote style={{ marginBottom: 1 }}>PIN: 93899991</PdfNote>
        <PdfNote style={{ marginBottom: 1 }}>PIN: 93899992</PdfNote>
        <PdfNote>PIN: 93899993</PdfNote>
      </PdfCol>
    </PdfRow>
  </PdfSection>
);
